import axiosInstance from "../../axios/axiosInstance";
import { ADMIN_LOGIN } from "../../constants";



export const adminLogin = (payload) => onResponse => {
    try {
        axiosInstance.post(ADMIN_LOGIN, payload)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


